import { Button } from '@mui/material';
import { IconPublish } from '../../../icons/Icon';
import UpdateProductionPlanTable from '../../../components/commonComponent/UpdateProductionPlanTable';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { fetchUpdateProductionPlan, saveUpdateProductionPlan, submitUpdateProductionPlan } from '../../../services/updateProductionPlanSlice';
import { useSelector } from 'react-redux';
import Loader from '../../../components/loader/Loader';
import { toast } from 'react-toastify';
import InfoModal from '../../../components/commonComponent/InfoModal';
import { NavigateFunction, useNavigate } from 'react-router-dom';


const UpdateProductionPlanDetails = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const navigate: NavigateFunction = useNavigate();
  const { params, updateProduction, loading } = useSelector((state: any) => state.updateProductionPlan);
  const { previousPlan } = useSelector((state: any) => state.productionPlan);
  const [openPublishModal, setOpenPublishModal] = useState<boolean>(false);
  const [openRedirectModal, setOpenRedirectModal] = useState<boolean>(false);
  const [selectedSites, setSelectedSites] = useState<object[]>([]);
  const userid = localStorage.getItem('userid');

  const submitUpdateProduction = () => {
    setOpenPublishModal((prev) => !prev);
    dispatch(submitUpdateProductionPlan({
      userid,
      menudate: params?.menudate,
      daypartid: params?.daypartid,
      reasonid: params?.reasonid,
      requestdishname: updateProduction[0]?.requestdishname,
      requestdishcode: updateProduction[0]?.requestdishcode,
      reviseddishname: updateProduction[0]?.reviseddishname,
      reviseddishcode: updateProduction[0]?.reviseddishcode,
      sitedetails: selectedSites
    })).unwrap().then((res: any) => {
      toast(res?.message, { type: "success" });
      dispatch(fetchUpdateProductionPlan(params))?.unwrap()?.then(() => {
        setSelectedSites([]);
        setOpenRedirectModal((prev) => !prev);
      })?.catch((error) => {
        console.error(" get update production plan API error::", error)
      })
    }).catch((error) => {
      console.error(" submit update production plan API error::", error)
    })
  }

  const handleSubmitUpdateProductionPlan = () => {
    if (!selectedSites?.length) {
      toast(`Please select any sites and cafes before submit`, { type: "info" });
    } else {
      setOpenPublishModal((prev) => !prev);
    }
  }

  const handleSaveUpdateProductionPlan = (savedetails: object) => {
    dispatch(saveUpdateProductionPlan({
      userid,
      menudate: params?.menudate,
      daypartid: params?.daypartid,
      ...savedetails
    })).unwrap().then(() => {
      //toast(res?.message, { type: "success" });
      getUpdateProductionPlan();
    }).catch((error) => {
      console.error("save update production plan API error::", error)
    })
  }

  const getUpdateProductionPlan = () => {
    dispatch(fetchUpdateProductionPlan(params));
  }

  useEffect(() => {
    setSelectedSites([]);
    getUpdateProductionPlan()
  }, [params]);

  return (
    <div className="white-box mb-12">
      <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">
        <div className="flex align-items-center">
        </div>
        <div className="button-wrap flex align-items-center">
          {/* <Button className='cmenu-btn' disableRipple>
            <IconDelete /> Clear Changes
          </Button> */}
          <Button onClick={handleSubmitUpdateProductionPlan} className="primary-btn btn-right ml-16" disabled={params?.isdisable} disableRipple>
            <IconPublish /> Submit
          </Button>
          {openPublishModal && (
            <InfoModal
              open={openPublishModal}
              handleClose={() => setOpenPublishModal((prev) => !prev)}
              handleOk={submitUpdateProduction}
              title="Submit"
              description="All changes will be submited. Are you sure you want to update the selected site and cafes?"
              closeText="No"
              submitText="Yes"
            />
          )}
          {openRedirectModal && (
            <InfoModal
              open={openRedirectModal}
              handleClose={() => setOpenRedirectModal((prev) => !prev)}
              handleOk={() => navigate(previousPlan ? "/previousproductionplan" : "/productionplan")}
              title="Redirect"
              description="Redirect to production plan. Are you sure you want to redirect to production plan?"
              closeText="No"
              submitText="Yes"
            />
          )}
        </div>
      </div>
      <div className="inner-contant kitchen-dashboard">
        <UpdateProductionPlanTable
          updateProductionList={updateProduction}
          selectedSites={selectedSites}
          setSelectedSites={setSelectedSites}
          handleSaveUpdateProductionPlan={handleSaveUpdateProductionPlan}
        />
      </div>
      {loading && <Loader />}
    </div>
  );
};
export default UpdateProductionPlanDetails;
